import { useCallback, useState } from 'react';

import type { AccountModalName, AccountModalType } from './AccountDetailsContext';

export function useAccountDetailsModalState() {
  const [activeModal, setActiveModal] = useState<AccountModalType>(null);
  const openModal = useCallback((type: AccountModalName) => setActiveModal(type), []);
  const closeModal = useCallback(() => setActiveModal(null), []);
  return { activeModal, openModal, closeModal };
}
